var HorizonJs_Url = /** @class */ (function () {
    function HorizonJs_Url() {
    }
    /**
     * @deprecated use a combination of bellow functions for more control
     */
    HorizonJs_Url.setParamInUrl = function (paramToAdd) {
        //Get parameter in url.
        var paramInUrl = this.getSearchParameters();
        //Test if there is a uid in url and replace it
        for (var property in paramInUrl) {
            if (paramInUrl.hasOwnProperty(property)) {
                paramToAdd[property] = paramInUrl[property];
            }
        }
        //Construct param
        var urlParam = '';
        var cursor = 0;
        for (var property in paramToAdd) {
            if (paramToAdd.hasOwnProperty(property)) {
                cursor++;
                urlParam += (cursor > 1 ? '&' : '?') + property + '=' + paramToAdd[property];
            }
        }
        //Replace Current Url
        var currentUrl = window.location.href;
        window.history.replaceState("", "", currentUrl.split("?")[0]);
    };
    HorizonJs_Url.changeCurrentLocation = function (newLocation, state) {
        if (state === void 0) { state = undefined; }
        window.history && window.history.replaceState(state, "", newLocation);
    };
    HorizonJs_Url.buildUrl = function (path, args, hash) {
        if (args === void 0) { args = {}; }
        if (hash === void 0) { hash = ''; }
        var buildedArgs = [];
        for (var key in args) {
            buildedArgs.push(key + '=' + args[key]);
        }
        if (path.indexOf('#') !== -1) { //delete existing hash if provided in the path
            var chash = path.substr(path.indexOf('#') + 1);
            path = path.substr(0, path.indexOf('#'));
        }
        if (hash.length > 0 && hash[0] === '#')
            hash = hash.substr(1);
        return path + (buildedArgs.length ? '?' : '') + buildedArgs.join('&') + (hash !== '' ? '#' : '') + hash;
    };
    HorizonJs_Url.buildUrlFromCurrentWithNewArgs = function (args) {
        if (args === void 0) { args = {}; }
        return HorizonJs_Url.buildUrl(window.location.href, args, window.location.hash);
    };
    HorizonJs_Url.buildUrlFromCurrentAddNewArgs = function (args) {
        if (args === void 0) { args = {}; }
        var fullArgs = HorizonJs_Url.getSearchParameters();
        for (var i in args) {
            fullArgs[i] = args[i];
        }
        return HorizonJs_Url.buildUrl(window.location.href, fullArgs, window.location.hash);
    };
    HorizonJs_Url.getSearchParameters = function () {
        var paramsStart = window.location.href.indexOf('?');
        if (paramsStart != -1) {
            var paramsEnd = window.location.href.indexOf('#', paramsStart);
            paramsEnd = paramsEnd == -1 ? window.location.href.length : paramsEnd;
            return this.transformSearchparametersToAssocArray(window.location.href.substring(paramsStart + 1, paramsEnd));
        }
        return {};
    };
    ;
    HorizonJs_Url.getSearchParametersInHashbang = function () {
        var paramsStart = window.location.hash.indexOf('?');
        if (paramsStart != -1) {
            return this.transformSearchparametersToAssocArray(window.location.hash.substring(paramsStart + 1));
        }
        return {};
    };
    ;
    HorizonJs_Url.transformSearchparametersToAssocArray = function (prmstr) {
        var params = {};
        var prmarr = prmstr.split("&");
        for (var i = 0; i < prmarr.length; i++) {
            var tmparr = prmarr[i].split("=");
            params[tmparr[0]] = tmparr[1];
        }
        return params;
    };
    ;
    HorizonJs_Url.getSearchParametersWithName = function (parameterName, defaultVal) {
        if (defaultVal === void 0) { defaultVal = null; }
        var param = HorizonJs_Url.getSearchParameters();
        return typeof param[parameterName] !== 'undefined' ? param[parameterName] : defaultVal;
    };
    HorizonJs_Url.parseJwt = function (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        var data = JSON.parse(window.atob(base64));
        if (typeof data['userId'] !== 'undefined') {
            return data;
        }
        else {
            throw "Invalid Token (missing 'userId')";
        }
    };
    HorizonJs_Url.getUrlWithoutSlashAtTheEnd = function (url) {
        if (url.charAt(url.length - 1) === '/') {
            return url.substring(0, url.length - 1);
        }
        else {
            return url;
        }
    };
    HorizonJs_Url.formatParam = function (params) {
        var url_a = new URL("https://url.com");
        if (params != null) {
            if (params.filters != null) {
                var url_filters = [];
                var filters = params.filters;
                if (filters.date != null && filters.date.length > 0) {
                    for (var _i = 0, _a = filters.date; _i < _a.length; _i++) {
                        var d = _a[_i];
                        setFilter(url_filters, "date", d.operator, d.value);
                    }
                }
                if (filters.paymentDate != null && filters.paymentDate.length > 0) {
                    for (var _b = 0, _c = filters.paymentDate; _b < _c.length; _b++) {
                        var d = _c[_b];
                        setFilter(url_filters, "paymentDate", d.operator, d.value);
                    }
                }
                if (filters.issuedDate != null && filters.issuedDate.length > 0) {
                    for (var _d = 0, _e = filters.issuedDate; _d < _e.length; _d++) {
                        var d = _e[_d];
                        setFilter(url_filters, "issuedDate", d.operator, d.value);
                    }
                }
                if (filters.unused != null)
                    setFilter(url_filters, "unused", filters.unused.operator, filters.unused.value);
                if (filters.paymentUid != null)
                    setFilter(url_filters, "payment_uid", filters.paymentUid.operator, filters.paymentUid.value);
                if (filters.type != null)
                    setFilter(url_filters, "type", filters.type.operator, filters.type.value);
                if (filters.creation_date != null)
                    setFilter(url_filters, "creation_date", filters.creation_date.operator, filters.creation_date.value);
                if (filters.fullname != null)
                    setFilter(url_filters, "fullname", filters.fullname.operator, filters.fullname.value);
                if (filters.email != null)
                    setFilter(url_filters, "email", filters.email.operator, filters.email.value);
                if (filters.orderUids != null) {
                    for (var _f = 0, _g = filters.orderUids; _f < _g.length; _f++) {
                        var f = _g[_f];
                        setFilter(url_filters, "order_uid", f.operator, f.value);
                    }
                }
                if (filters.number != null)
                    setFilter(url_filters, "number", filters.number.operator, filters.number.value);
                if (filters.label != null)
                    setFilter(url_filters, "label", filters.label.operator, filters.label.value);
                if (filters.validated != null)
                    setFilter(url_filters, "validated", filters.validated.operator, filters.validated.value);
                if (filters.totalAmount != null)
                    setFilter(url_filters, "totalAmount", filters.totalAmount.operator, filters.totalAmount.value * 100);
                if (filters.totalAmountWithVat != null)
                    setFilter(url_filters, "totalAmountWithVat", filters.totalAmountWithVat.operator, filters.totalAmountWithVat.value * 100);
                if (url_filters.length > 0)
                    url_a.searchParams.set("filters", JSON.stringify(url_filters));
            }
            if (params.arguments != null) {
                url_a = setArgument(url_a, "elementsToReturn", params.arguments.elementsToReturn);
                url_a = setArgument(url_a, "before", params.arguments.before);
                url_a = setArgument(url_a, "after", params.arguments.after);
            }
        }
        return url_a.search;
        function setFilter(filter, key, operator, value) {
            if (value != null && operator !== null) {
                filter.push(key + operator + value);
            }
            return filter;
        }
        function setArgument(url, key, value) {
            if (value != null) {
                url.searchParams.set(key, value + '');
            }
            return url;
        }
    };
    return HorizonJs_Url;
}());
export { HorizonJs_Url };
//# sourceMappingURL=Url.js.map